<div appPreventDoubleClick
     [throttleTime]="700"
     (throttledClick)="onClick()"
     class="flex justify-center cursor-pointer"
     [ngClass]="{'w-full': isFullWidth, 'tk-c-gray-9': isDisabled}">
  <div class="flex align-middle">
    <mat-icon *ngIf="!isLoading" [ngClass]="getIconClasses()">
      {{finalIcon}}
    </mat-icon>
    <div *ngIf="isLoading" [ngClass]="spinnerClasses">
      <mat-spinner id="secondary-button-spinner" [strokeWidth]="spinnerStrokeWidth" [diameter]="spinnerDiameter" color="warn"></mat-spinner>
    </div>
    <div class="ml-1" [ngClass]="textClasses" (mouseover)="onHover(true)" (mouseout)="onHover(false)">
      {{label}}
    </div>
  </div>

</div>
